<template>
  <section class="container mb-4">
    <div class="box">
      <div class="row">
        <div class="col-12 col-md-7">
          <h2>{{ 'title' | translate(labels) }}</h2>
          <p v-html="subtitle" />
        </div>
        <div class="col-12 col-md-5 text-md-right font-condensed">
          <template v-for="(document, i) in componentConfig.documents">
            <div :key="'document' + i">
              <a :href="document.assetLink" target="_blank">
                <i class=" text-primary mr-2" :class="'fas fa-' + document.icon" />{{ document.documentDownloadsLabel }}
              </a>
            </div>
          </template>

          <template v-for="(link, i) in releaseNotes">
            <div :key="'releaseNotes_' + i">
              <b-link class="font-condensed" :href="link.url" target="_blank"><b-icon icon="file" class="mr-1 text-large" />{{ link.label }}</b-link>
            </div>
          </template>
        </div>
      </div>


      <template v-for="(link, i) in componentConfig.softwares">
        <SoftwareLink :key="'software' + i" :link="link" @error="errorSoftware = true" @releaseNotes="addReleaseNotes" />
      </template>

      <div v-if="inMgnl" class="box">
        Notice: These are mocked data for rendering purposes only
      </div>

      <div v-if="errorSoftware" class="box"><b-icon icon="exclamation-triangle" class="small align-self-end text-gray-600 mr-2" /> {{ 'defaultError' | translate(labels, 'CommonErrors') }}</div>
    </div>
  </section>
</template>

<script>
import {inMgnl} from '@/helpers/magnolia-helper'
import SoftwareLink from './SoftwareLink'

export default {
  conceptName: ['CommonErrors'],
  components: {SoftwareLink},
  data() {
    return {
      componentConfig: this.config,
      errorSoftware: false,
      releaseNotes: [],
      inMgnl: inMgnl
    }
  },
  computed: {
    subtitle() {
      return this.componentConfig.subtitle ? this.translatedConfig('subtitle') : ''
    }
  },
  created() {
    this.$store.dispatch('fetchConcepts', 'en')
  },
  methods: {
    addReleaseNotes(link) {
      this.releaseNotes.push(link)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
